var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2435_24250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49858 16C4.0891 16 0.5 12.4109 0.5 7.99858C0.5 3.58626 4.0891 0 8.49858 0C12.908 0 16.4972 3.5891 16.4972 7.99858C16.4972 12.408 12.908 15.9972 8.49858 15.9972V16Z",
    fill: "#3395FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50168 4.75977C8.3792 4.75977 8.27665 4.79965 8.19689 4.87655C8.10859 4.96486 8.06017 5.09874 8.06017 5.25256V7.40317C8.05732 7.80766 8.05447 8.22639 8.06586 8.63657C8.06586 8.74196 8.11144 8.87015 8.17695 8.96699C8.27095 9.10372 8.4618 9.15499 8.64411 9.09233C8.82926 9.02681 8.94035 8.86445 8.94035 8.65651C8.94035 7.52281 8.94035 6.38911 8.94035 5.2554C8.94035 4.95346 8.76944 4.75977 8.50168 4.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05153 11.0522C8.16831 11.1718 8.32498 11.2373 8.49304 11.2373H8.49589C8.84341 11.2373 9.12541 10.9582 9.12826 10.6135C9.12826 10.266 8.8491 9.98112 8.50444 9.97827H8.49874C8.33353 9.97827 8.17971 10.0438 8.06007 10.1606C7.94043 10.2802 7.87207 10.4369 7.87207 10.6049C7.87207 10.773 7.93474 10.9325 8.05437 11.0522H8.05153Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2435_24250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/Info2.573e8ee6100b742b58499ba3648cb688.svg";
export { ForwardRef as ReactComponent };